import { Action } from '@ngrx/store';
import { IBankDetailsState } from './../../state/bank-details.state';
import { IRegistrantsState } from './../../state/registrants.state';
import { IInvestorDetailsState } from './../../state/investor-details.state';
import { IRegistrationStatusState } from './../../state/registration.state';
import { InvestorDetailsReducer } from "./investor-details.reducer";
import { RegistrantReducer } from "./registrant.reducer";
import { BankDetailsReducer } from "./bank-details.reducer";
import { RegistrationStatusReducer } from "./registrationStatus.reducer";

export type Reducer<T> = (state: T, action: Action) => T;


export interface IRegistrationState {
    status: Reducer<IRegistrationStatusState>;
    investor: Reducer<IInvestorDetailsState>;
    registrants: Reducer<IRegistrantsState>;
    banks: Reducer<IBankDetailsState>;
}

export const RegistrationReducers: IRegistrationState = {
    status: RegistrationStatusReducer,
    investor: InvestorDetailsReducer,
    registrants: RegistrantReducer,
    banks: BankDetailsReducer
};
